var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sq-player-wrap"},[_c('div',{ref:_vm.playerName,class:{'kplayer': _vm.playerClass,'aplayer': !_vm.playerClass},style:({width:_vm.width,height:_vm.height}),on:{"click":_vm.play2pause}})])
}
var staticRenderFns = []

export { render, staticRenderFns }